import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { filterTaskForCalendar, getCustomWeekday } from '../functions';
import { RootState } from '../store';
import { DayWeekType, ItemTaskType, ItemType, TaskType } from '../types';

const useTasks = (typeDayWeek: DayWeekType) => {
    const filteredItems = useSelector<RootState, ItemType[]>((state) => state.calendar.filteredItems);
    const currentDate = useSelector<RootState, string>((state) => state.calendar.currentDate);
    const tasks = useSelector<RootState, ItemTaskType[]>((state) => state.calendar.tasks);

    const [filteredTaskList, setFilteredTaskList] = useState<TaskType[]>([]);

    useEffect(() => {
        setFilteredTaskList(
            tasks.filter(filterTaskForCalendar(currentDate, typeDayWeek)).map((task): TaskType => {
                const timeStart = DateTime.fromISO(task.start_datetime);
                const timeEnd = DateTime.fromISO(task.end_datetime);
                const weekDayItemDate = getCustomWeekday(DateTime.fromISO(task.datetime));

                const reCalcWeekDay = weekDayItemDate + 1 === 7 ? 0 : weekDayItemDate + 1;

                return {
                    ...task,
                    row: timeStart.hour * 2 + timeStart.minute / 30,
                    height: timeEnd.diff(timeStart, 'minute').minutes / 30,
                    col: typeDayWeek === 'day' ? 0 : reCalcWeekDay,
                };
            }),
        );
    }, [filteredItems, tasks]);

    return filteredTaskList;
};

export default useTasks;
